import { supabase } from "../../../../Backend/supabaseClient";
import { getCurrentUserId } from "../../../../Backend/Authentication/UserStore";

/**
 * Returns tests in UI format:
 * [{ id, title, score, totalQuestions, createdAt }]
 */
export async function fetchUserTests() {
    let userId = getCurrentUserId();
    if (!userId) throw new Error("userId is required");

    const { data, error } = await supabase
        .from("test_history")
        .select("id, title, score, total_questions, created_at, user_id")
        .eq("user_id", userId)
        .order("created_at", { ascending: false });

    if (error) throw new Error(error.message);

    // Map DB fields -> UI fields
    return (data || []).map((t) => ({
        id: t.id,
        title: t.title ?? "Untitled Test",
        score: t.score ?? 0,
        totalQuestions: t.total_questions ?? 0,
        createdAt: t.created_at,
    }));
}
